import { Dispatch, SetStateAction } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import useTranslation from "src/hooks/useTranslation";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { AlertType } from "src/api/types";
import { BalanceMonitorThresholdFields } from "./types";

function AlertTypeSection<T extends BalanceMonitorThresholdFields>({
  fields,
  setFields,
}: {
  fields: T;
  setFields: Dispatch<SetStateAction<T>>;
}) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);

  return (
    <FormControl
      fullWidth
      sx={{
        display: "grid",
        gridTemplateColumns: "100px 1fr",
        gap: "8px",
        alignItems: "center",
      }}
    >
      <FormLabel
        id="row-radio-buttons-group-label"
        sx={{ color: "rgba(0, 0, 0, 0.87)" }}
      >
        {t("alert_type")}
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby="row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        onChange={(e, value) =>
          setFields((prev) => ({ ...prev, alertType: Number(value) }))
        }
        value={fields.alertType}
      >
        <FormControlLabel
          value={AlertType.FixedThreshold}
          control={<Radio />}
          label={t("fixed_threshold")}
        />
        <FormControlLabel
          value={AlertType.DynamicThreshold}
          control={<Radio />}
          label={t("dynamic_threshold")}
        />
      </RadioGroup>
    </FormControl>
  );
}

export default AlertTypeSection;
